import React from 'react';

import classNames from 'classnames';

import ComponentType from '../../../types/Component';
import Modal from '../Modal';
import RemoveIcon from '../icons/Remove';

import style from './style.module.scss';

type DialogType = {
	onClose: () => void;
	title?: string | JSX.Element;
	className?: string;
	actions?: JSX.Element[];
	width?: string | number;
	visible?: boolean;
};

const Dialog: ComponentType<DialogType> = ({
	title,
	children,
	className,
	actions,
	width,
	onClose,
	visible,
}) => {
	return (
		<Modal visible={visible} onClose={onClose}>
			<div className={classNames([style.uiDialogWindow, className])} style={{ width }}>
				<div className={style.uiDialogHeader}>
					<div className={style.uiDialogTitle}>{title}</div>
					<div className={style.uiDialogClose} onClick={onClose}>
						<RemoveIcon />
					</div>
				</div>
				<div className={style.uiDialogContent}>{children}</div>
				{!!actions && (
					<div className={style.uiDialogActions}>
						{actions.length
							? React.Children.map(actions, (action, key) => (
									<div className={style.uiDialogAction} key={key}>
										{React.cloneElement(action, { key })}
									</div>
							  ))
							: actions}
					</div>
				)}
			</div>
		</Modal>
	);
};

export default Dialog;
